<template>
  <div class="flex gap-3 px-1 items-center">
    <span> {{ queryCol.column.label }} </span>
    <div v-if="queryCol.list === 'measure'">
      <Select
        v-if="props.editable"
        v-model="queryCol.measure_type"
        :options="aggregators"
      />
      <b v-else>
        {{ queryCol.measure_type }}
      </b>
    </div>
    <div v-if="queryCol.list === 'filter'">
      <Select
        v-if="props.editable"
        v-model="queryCol.filter_operator"
        :options="operators"
        @change="getFilterValue"
      />
      <b v-else>
        {{ queryCol.filter_operator }}
      </b>
    </div>
    <FilterValue
      v-if="queryCol.list === 'filter'"
      v-model="queryCol.filter_value"
      :multiple="
        queryCol.filter_operator === 'IN' ||
        queryCol.filter_operator === 'NOT IN'
      "
      :editable="props.editable"
    />
    <CloseButton
      v-if="props.editable"
      @close="emit('close', queryCol.uniqueKey)"
    ></CloseButton>
  </div>
</template>

<script setup>
import { defineEmits, defineModel, defineProps, ref } from "vue";
import Select from "primevue/select";
import FilterValue from "@/components/information_tabs/query_elements/FilterValue.vue";
import CloseButton from "@/components/closeButton.vue";

const emit = defineEmits(["close"]);
const queryCol = defineModel();
const props = defineProps({ editable: { type: Boolean, default: true } });

const operators = ref([
  "IN",
  "NOT IN",
  "LIKE",
  "NOT LIKE",
  "=",
  "!=",
  "IS",
  "IS NOT",
  "<",
  ">",
  "<=",
  ">=",
]);

const aggregators = ref([
  "count",
  "count_distinct",
  "sum",
  "min",
  "max",
  "avg",
  "any_value",
  "array_agg",
  "array_agg_distinct",
]);

function getFilterValue() {
  if (
    queryCol.value.filter_operator === "IN" ||
    queryCol.value.filter_operator === "NOT IN"
  ) {
    return;
  }
  queryCol.value.filter_value = queryCol.value.filter_value.slice(0, 1);
}
</script>

<style scoped>
.p-select {
  --p-select-padding-y: 0;
  --p-select-padding-x: 0.7rem;
  --p-select-dropdown-width: 1.5rem;
  height: 1.9rem;
  border: 0;

  & :deep(.p-select-label) {
    display: flex;
    align-items: center;
  }
}
</style>
